export default __webpack_public_path__ + "69ceb968271b637b3c686c546dca894d.svg";